import { RELATIVE_ALL_TIME } from "views/Constants";
import { isTypeRelativeWithStartOnly, isTypeRelativeWithEnd } from "views/typeGuards/timeRange";
export const onInitializingTimerange = (timerange, formatTime) => {
  const { type } = timerange;
  switch (timerange.type) {
    case "absolute":
      return {
        type: timerange.type,
        from: formatTime(timerange.from, "complete"),
        to: formatTime(timerange.to, "complete")
      };
    case "relative":
      if (isTypeRelativeWithStartOnly(timerange)) {
        if (timerange.range === RELATIVE_ALL_TIME) {
          return {
            type: timerange.type,
            range: timerange.range
          };
        }
        return {
          type: timerange.type,
          from: timerange.range
        };
      }
      if (isTypeRelativeWithEnd(timerange)) {
        if ("to" in timerange) {
          return {
            type: timerange.type,
            from: timerange.from,
            to: timerange.to
          };
        }
        return {
          type: timerange.type,
          from: timerange.from
        };
      }
      throw new Error("Invalid relative time range");
    case "keyword":
      return timerange;
    default:
      throw new Error(`Invalid time range type: ${type}`);
  }
};
